module.exports = __webpack_public_path__ + "static/media/openTip3.92b3be9.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/mp3/openTip3.mp3
// module id = YL5R
// module chunks = 1